module.exports = __webpack_public_path__ + "202408221624/img/zpace_icon_set.1e07ffe2.png";